import {
  Alert,
  Col,
  FormControl,
  FormGroup,
  Grid,
  Media,
  Row
} from 'react-bootstrap';
import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';

import Card from './Card/Card.jsx';
import CustomButton from '../elements/CustomButton/CustomButton';
import { FormattedMessage } from 'react-intl';
import Queries from '../queries/queries2';
import Spinner from '../elements/Spinner/Spinner';
import { injectIntl } from 'react-intl';
import querySearch from 'stringquery';
import { withRouter } from 'react-router-dom';

// import ReactPasswordStrength from "react-password-strength";

// import { withRouter } from "react-router-dom";

class ChangePasswordPage extends Component {
  constructor(props) {
    super();
    this.state = {
      firstname: '',
      password: '',
      error: null
    };
  }

  componentDidMount(prevProps) {
    const qsParams = querySearch(
      // encodeURI(
      this.props.location.search
    );

    // )
    console.log('qsPArams', qsParams);
    let newState = {
      ...this.state
    };
    this.setState(newState);

    console.log('newState', newState);

    const url = process.env.REACT_APP_GRAPHQL_ENDPOINT + '/verifyResetPassword';

    console.log('url', url);

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ token: qsParams.token })
    })
      .then(res => res.json())
      //        .then(res => res.text())
      .then(body => {
        console.log(body);
        this.setState({ verified: body.verified, token: qsParams.token });
      });
  }

  render() {
    const { intl } = this.props;

    console.log('state', this.state);

    // const qsParams = querySearch(location.search);
    if (!this.state.verified) {
      return (
        <Grid>
          <Card>
          <Row>
            <Col md={8} mdOffset={2}>
              <div className="header-text">
                <img alt="" src={'/LogoNetWips_Mail.png'} />
                {/* <h2>{intl.formatMessage({ id: "ids_netwips" })}</h2> */}
                {/* <h4>{intl.formatMessage({ id: "ids_newPasswordTitle" })}</h4> */}
                <hr />
              </div>
            </Col>
            <Col md={6} mdOffset={2}>
              <Media>
                {/* <Media.Left /> */}
                <Media.Body>
                  <Media.Heading>
                    {intl.formatMessage({
                      id: 'ids_invalidConnectionIDs'
                    })}
                    <br />
                    <br />
                    {intl.formatMessage({
                      id: 'ids_invalidConnectionIDs2'
                    })}
                    <br />
                  </Media.Heading>
                </Media.Body>
              </Media>
            </Col>
          </Row>
          </Card>
        </Grid>
      );
    } else if (
      this.props.LoggedInUserQuery &&
      this.props.LoggedInUserQuery.loading
    ) {
      return <Spinner size="lg" fullScreen />;
    }
    return (
      <Grid>
        <Card >
          <Row >
            <Col md={8} mdOffset={2} >
              <div className="header-text" >
                <img alt="" src={'/LogoNetWips_Mail.png'} />
                {/* <h2>{intl.formatMessage({ id: "ids_netwips" })}</h2> */}
                {/* <h4>{intl.formatMessage({ id: "ids_newPasswordTitle" })}</h4> */}
                <hr />
              </div>
            </Col>
            <Col md={4} mdOffset={2}>
              <Media>
                {/* <Media.Left /> */}
                <Media.Body>
                  <Media.Heading>
                    {intl.formatMessage({
                      id: 'ids_resetPassword'
                    })}
                    <br />
                    <br />
                    {intl.formatMessage({
                      id: 'ids_resetPassword2'
                    })}
                    <br />
                  </Media.Heading>
                  {/* {intl.formatMessage({ id: "ids_newPasswordSubtitle" })} */}
                </Media.Body>
              </Media>
            </Col>
            <Col md={3}>
              <form style={{ paddingTop: '50px' }}>
                <Card
                  plain
                  content={
                    <div>
                      <FormGroup>
                        <FormControl
                          type="password"
                          placeholder={intl.formatMessage({ id: 'ids_password' })}
                          value={this.state.password}
                          onChange={e =>
                            this.setState({ password: e.target.value })
                          }
                        />
                      </FormGroup>
                      {false && (
                        <Alert bsStyle="danger">
                          <button
                            type="button"
                            aria-hidden="true"
                            className="close"
                          >
                            ×
                        </button>
                          <span>
                            <FormattedMessage id="ids_invalidConnectionIDs" />
                          </span>
                        </Alert>
                      )}
                      {/* <FormGroup>
                        <FormControl
                        type="password"
                        placeholder="Password Confirmation"
                        />
                      </FormGroup> */}
                    </div>
                  }
                  ftTextCenter
                  legend={
                    <CustomButton
                      wd
                      bsStyle="info"
                      fill
                      // primary
                      wide
                      block
                      // neutral
                      onClick={this.resetPassword}
                      disabled={this.state.password.length === 0}
                    >
                      {intl.formatMessage({ id: 'ids_save' })}
                    </CustomButton>
                  }
                />
              </form>
            </Col>
          </Row>
        </Card>
      </Grid>
    );
  }

  resetPassword = async () => {
    const { token, password } = this.state;
    const variables = { newPassword: password, token };

    const res = await this.props.resetPassword({
      variables
    });
    console.log('resetPassword result', res);
    sessionStorage.removeItem('companyId');
    localStorage.setItem('graphcoolToken', res.data.resetPassword.token);
    this.props.history.replace('/companies');
  };
}

export default compose(
  graphql(Queries.resetPasswordMutation, { name: 'resetPassword' })
)(injectIntl(withRouter(ChangePasswordPage)));
